import styled from '@emotion/styled';
export const LanguageSwitcherList = styled('ul')(({ theme }) => ({
    listStyle: 'none',
    padding: '0',
    marginTop: theme.spacing[200],
    '[aria-current="page"]': {
        fontWeight: 400,
        color: theme.color.font.base,
    },
    '[aria-current="page"]:hover': {
        textDecoration: 'none',
    },
}));
export const LanguageSwitcherToggleButton = styled('a')(({ theme }) => ({
    color: theme.color.font.inverseBase,
    display: 'none',
    gap: theme.spacing[200],
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    border: 0,
    borderRadius: theme.borderRadius[100],
    fontWeight: theme.typography.fontWeight.openSans.bold,
    fontSize: theme.typography.fontSize['xl'],
    fontFamily: 'inherit',
    height: '3.8rem',
    padding: `0 ${theme.spacing[200]}`,
    textTransform: 'none',
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
        background: theme.color.background.interactiveInverseHovered,
    },
    [theme.breakpoint.minWidth('md')]: {
        display: 'inline-flex',
    },
}));
//# sourceMappingURL=LanguageSwitcher.styled.js.map